import { render, staticRenderFns } from "./TaskListItemCard.vue?vue&type=template&id=703bc0b3&scoped=true"
import script from "./TaskListItemCard.vue?vue&type=script&lang=js"
export * from "./TaskListItemCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703bc0b3",
  null
  
)

export default component.exports